<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import createModal from "./create_modal.vue";
import balanceModal from "./balance_modal.vue";
import abilityModal from "./abilities.vue";
import { globalStatus }  from "../../../helpers/helper"

export default {
  page: {
    title: "Bayi Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    createModal,
    balanceModal,
    abilityModal
  },
  data() {
    return { 
        list: {},
        title: "BAYİ LİSTESİ",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "BAYİ LİSTESİ",
            active: true,
          },
        ],
        isLoading: false,
        rows: [],
        opened:0,
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        selected: 0,
        pageLength: 0,
        url: "dealers",
        paginationOptions: {
          enabled: true,
          dropdownAllowAll: false,
          perPage: 50,
          setCurrentPage: 1,
          perPageDropdown: [50, 100, 200],
          nextLabel: 'Sonraki',
          prevLabel: 'Önceki',
          rowsPerPageLabel: 'Kayıt Göster',
          ofLabel: 'of',
          pageLabel: 'sayfa', // for 'pages' mode
          infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
      },
      selectOptions: {
        enabled: false,
        selectOnCheckboxOnly: false,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
      columns: [
        {
          field: '#',
          sortable: false,
          thClass: 'width-50',
        },
        {
          label: 'İsim Soyisim',
          field: 'name',
          filterOptions: {
            enabled: true,
            placeholder: 'İsim Soyisim Filtrele',
            filterDropdownItems: [],
          },
        },
        {
          label: 'Kullanıcı Adı',
          field: 'username',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Kullanıcı Adı Filtrele',
            filterDropdownItems: [ ],
          },
        },
      ],
    };
  },
   mounted() {
    this.loadItems()
  },
  methods: {
    status(rowObj) {
      return globalStatus(rowObj.status);
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
      })
    },
    getFromServer() {
    return new Promise((resolve, reject) => {
        this.$http.post(this.url, this.serverParams)
          .then(res => {
            resolve({
              rows: res.data.data,
              totalRecords: res.data.total,
              pageLength: res.data.last_page,
              currentPage: res.data.current_page,
            })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    selectionChanged(a) {
      this.selected = a.selectedRows.length
    },
    onSearch(params) {
       this.updateParams(params)
        this.loadItems()
    },
    create(){
       this.list = {}
       this.$parent.$bvModal.show('modal-scoped')
    },
    update(props, type){
       this.list = { ...props, type}
       this.$parent.$bvModal.show('modal-scoped')
    },
    balance(props){
       this.list = props
       this.opened += 1;
       this.$parent.$bvModal.show('modal-balance')
    }, 
    ability(props){
       this.list = props
       this.$parent.$bvModal.show('modal-ability')
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <create-modal :list="list" @loadItems="loadItems"/>
    <balance-modal 
        :list="list" 
        :opened="opened" 
        @loadItems="loadItems"/>

    <ability-modal :list="list"/>
    <div class="row">     
      <div class="col-12">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{
                    enabled: false,
                    placeholder: 'Arama İçin Enter\'a Basınız'
                  }"
                @on-search="onSearch"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-selected-rows-change="selectionChanged"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <div slot="table-actions">
                    <button 
                    class="btn btn-success btn-sm" 
                    style="margin-right:10px;margin-top:2px" 
                    type="button" 
                    @click="create()"
                    >Yeni Oluştur
                    </button>
                </div>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <b-dropdown
                    v-if="props.column.field === '#'"
                    class="ms-2 "
                    toggle-class="font-size-16 p-0"
                    toggle-tag="a"
                    variant="white"
                    right
                >
                    <template #button-content>
                      <i class="mdi mdi-dots-horizontal"></i>
                    </template>
                    <template>
                        <b-dropdown-item @click="update(props.row,'update')">Düzenle</b-dropdown-item>
                        <b-dropdown-item @click="update(props.row,'password')">Şifre Güncelle</b-dropdown-item>
                        <b-dropdown-item>Sil</b-dropdown-item>
                    </template>
                  </b-dropdown>
                </template>
            </vue-good-table>
        </div>
    </div>
  </Layout>
</template>
